<template>
    <div>
        <div class="header">
            <div class="back" @click="back( 1 )">
                <span class="icon-dropdown_up"></span>
                indietro
            </div>
            <div class="sf2__title--left-stroke title--xs">La tua spesa con <br><strong class="colorize">Link</strong></div>
        </div>

        <div class="switchRow">
            <SwitchBox class="small-label" :question="range.question" :option_a="range.a" :option_b="range.b" @onChange="setRange" />
            <SwitchBox class="small-label" :question="power.question" :option_a="power.a" :option_b="power.b" @onChange="setPower" />
        </div>

        <div class="prices" :class="{ dual: commodity == 'dual' }">
            <div v-if="light > 0" class="price luce">
                <span class="colorize">LUCE</span>
                <div class="value">
                    <span class="big">{{ rate.light.firstYear }}</span><span>,00<span> €</span><br>{{lapse}}</span>
                </div>
                <div class="fullPrice">€ {{ rate.light.final }}/{{unit}} dal secondo anno</div>
            </div>
            <div v-if="light <= 0" class="missing">
                Vuoi fare una stima<br>
                della spesa per la <strong>Luce</strong>?<br>
                <u @click="back( 2 )">Inserisci i tuoi consumi</u>.
            </div>
            
            <div v-if="gas > 0" class="price gas">
                <span class="colorize">GAS</span>
                <div class="value">
                    <span class="big">{{ rate.gas.firstYear }}</span><span>,00<span> €</span><br>al {{lapse}}</span>
                </div>
                <div class="fullPrice">€ {{ rate.gas.final }}/{{unit}} dal secondo anno</div>
            </div>
            <div v-if="gas <= 0" class="missing">
                Vuoi fare una stima<br>
                della spesa per il <strong>Gas</strong>?<br>
                <u @click="back( 2 )">Inserisci i tuoi consumi</u>.
            </div>
        </div>

        <div class="info" v-if="digital">
            I prezzi indicati includono già lo Sconto Digitale. La bolletta verrà inviata con cadenza bimestrale.
        </div>

        <div class="lock-down">
            <button class="sf2-btn" sf-cart-modal-switch="slide-up">Attiva <strong>LINK</strong></button>
        </div>
    </div>
</template>

<script>

    import SwitchBox from '../../../elements/SwitchBox.vue';

    import Gas from '../Gas.js';
    import Light from '../Light.js';
    import Zip from '../Zip.js';

    //- Products ---
        import { Link } from "../../../model/Products.js"; 

    export default {
        name: "Prices",
        components: {
            SwitchBox
        },
        props: {
            mono: Boolean,
            commodity: String,
            digital: Boolean,
            bollettino: Boolean,
            resident: Boolean,
            zip: String,
            gas: Number,
            light: Number,
        },
        watch: {
            $props: {
                handler() {
                    this.hide();
                },
                deep: true,
                immediate: true,
            },
        },
        data() {
            return {
                expenditure: {
                    gas: 0,
                    light: 0,
                    gasFirstYear: 0,
                    lightFirstYear: 0,
                    scontoDigitale:true
                },
                range: {
                    question: 'Prezzo',
                    a: 'Mese',
                    b: 'Anno',
                    current: 12
                },
                power: {
                    question: 'Contatore da',
                    a: '3kW',
                    b: '6kW',
                    current: '3'
                },
                offerta: {
                    option: '',
                    utility: '',
                    bolletta: '',
                    pagamento: ''
                },
                rate: {
                    gas: {
                        final: 0,
                        firstYear: 0
                    },
                    light: {
                        final: 0,
                        firstYear: 0
                    }
                },
                moltiplicator: {
                    digital: 0.1,
                    firstYear: 0.1
                }
            };
        },
        created: function () {
            this.zipService = Zip;
            this.gasService = Gas;
            this.lightService = Light;
            this.linkProduct = new Link;
        },
        mounted() {
            console.log('Cart mounted ', this.default);

            this.calculate();
        },
        computed: {
            lapse: function () {
                // `this` points to the vm instance
                return ( this.range.current == 1 ) ? 'anno' : 'mese';
            },
            unit: function () {
                // `this` points to the vm instance
                return ( this.range.current == 1 ) ? 'all\'anno' : 'al mese';
            }
        },
        methods: {
            setRange(event) {
                console.log('Cart price setRange', event.val);

                this.range.current = ( event.val == "Mese" ) ? 12 : 1;

                this.calculate();
            },
            setPower(event) {
                console.log('Cart price setPower', event.val);

                this.power.current = ( event.val == "3kW" ) ? 3 : 6;

                this.calculate();
            },
            calculateGasRate(expenditure) {
                console.log('Cart calculateGasRate', expenditure);

                return expenditure / this.range.current;
            },
            calculateLightRate(expenditure) {
                console.log('Cart calculateLightRate', expenditure);

                return expenditure / this.range.current;
            },
            hide() {
                this.calculate();
            },
            calculateExpenditure() {
                console.log( 'Prices calculateExpenditure', this.gas, this.light, this.mono, this.resident, this.power.current );

                const digital = ( this.digital==true && this.bollettino==false ) ? true : false;

                const moltiplicator = 1 - ( digital ? this.moltiplicator.digital : 0);
                const moltiplicatorFirstYear = 1 - ( digital ? (this.moltiplicator.firstYear + this.moltiplicator.digital) : this.moltiplicator.firstYear);

                console.log( 'Prices calculateExpenditure moltiplicator', this.digital, this.bollettino, moltiplicator, moltiplicatorFirstYear );

                if ( this.gas ){
                    this.expenditure.gas = this.gasService.expenditure( this.gas, this.zipService.getRegion( this.zip ), false, moltiplicator ); 
                    this.expenditure.gasFirstYear = this.gasService.expenditure( this.gas, this.zipService.getRegion( this.zip ), false, moltiplicatorFirstYear ); 
                } else {
                    this.expenditure.gas = 0;
                }

                if ( this.light ){
                    if ( this.mono ){
                        console.log( 'Prices calculateExpenditure MONO' );
                        this.expenditure.light = this.lightService.expenditure( this.light, 0, this.linkProduct, this.power.current, this.resident, moltiplicator ); 
                        this.expenditure.lightFirstYear = this.lightService.expenditure( this.light, 0, this.linkProduct, this.power.current, this.resident, moltiplicatorFirstYear ); 
                    } else {
                        console.log( 'Prices calculateExpenditure DUAL' );

                        let f1 = this.light * 0.15;
                        let f2 = this.light * 0.85;

                        this.expenditure.light = this.lightService.expenditure( f1 * moltiplicator, f2 * moltiplicator, this.linkProduct, this.power.current, this.resident ); 
                        this.expenditure.lightFirstYear = this.lightService.expenditure( f1 * moltiplicatorFirstYear, f2 * moltiplicatorFirstYear, this.linkProduct, this.power.current, this.resident ); 
                    }
                } else {
                    this.expenditure.light = 0;
                }

                console.log( 'Configuratore calculate expenditure', this.expenditure );
            },
            calculate() {
                this.calculateExpenditure();

                console.log('Cart calculate');

                this.rate.gas.final = this.calculateGasRate( this.expenditure.gas );
                this.rate.light.final = this.calculateGasRate( this.expenditure.light );

                this.rate.gas.final = this.rate.gas.final.toFixed(2).replace(".", ",");
                this.rate.light.final = this.rate.light.final.toFixed(2).replace(".", ",");

                this.rate.gas.firstYear = Math.floor( this.calculateGasRate( this.expenditure.gasFirstYear ) );
                this.rate.light.firstYear = Math.floor( this.calculateGasRate( this.expenditure.lightFirstYear ) );
            },
            back( n ) {
                console.log( 'Price emit onBack' );

                this.$emit( 'onBack', n );
            }
        },
    };
</script>

<style scoped lang="scss">

    .sf2__title--left-stroke { margin-bottom: 30px; 
        .colorize {font-size: 30px;}
    }

    .info {
        font-size: 12px; color: #767676; padding:0 0 0 50px; position: relative; margin-top: 15px;

        &::after {
            content: '\e9bd'; position: absolute; left: 0; top: 50%; transform: translateY(-50%); font-family: 'EGL-Icon-font' !important;
            font-size: 21px;
        }
    }

    .prices {
        position: relative;
        .price {
            padding:15px 15px 15px 95px; position: relative; border-radius: 10px; margin-top: 15px;
            box-shadow: 0 0 20px 0 rgba(51, 51, 51, 0.15);
            // &.gas::before { content: '\e901'; position: absolute; top: 50%; left: 15px; transform: translateY(-50%); font-family: 'EGL-Icon-font' !important; font-size: 40px; font-weight: normal;}
            // &.luce::before { content: '\e900'; position: absolute; top: 50%; left: 15px; transform: translateY(-50%); font-family: 'EGL-Icon-font' !important; font-size: 40px; font-weight: normal;}

            > span {position: absolute; top: 50%; left: 20px; transform: translateY(-50%); font-size: 20px; font-weight: bold;
                border-right: 1px solid #d8d8d8; padding-right: 20px; line-height: 65px;
            }
            
            .value {
                font-size: 18px; display: flex; vertical-align: top; line-height: 21px;
                .big {font-size: 60px; line-height: 40px; font-weight: 700;}
                > *:last-child {margin-left: 9px;}
            }

            .fullPrice { color: #767676; font-size: 12px; padding-top: 6px;}

            @media (max-width: 767px) {
                padding-left: 70px;

                > span {left: 10px;padding-right: 10px;
                }
            }
            
        }
    }

    .missing {
        padding:15px; position: relative; border-radius: 10px; background: #f4f4f4; margin-top: 15px; text-align: center; font-size: 16px;
        line-height: 20px;

        u {cursor: pointer;}
    }

    .switchRow { display: flex; justify-content: space-between;
        > div { width: calc( 50% - 15px); }
    }

    button {margin-top: 30px;}

</style>